const config = {
  zakat: {
    flashTitle: 'zakat_inactive',
  },
  samolnas: {
    flashTitle: 'samolnas_inactive',
  },
  esamsat: {
    flashTitle: 'esamsat_inactive',
  },
  signal: {
    flashTitle: 'signal_inactive',
  },
  'government-revenue': {
    flashTitle: 'government_revenue_inactive',
  },
  bukadonasi: {
    flashTitle: 'bukadonasi_inactive',
  },
  'property-tax': {
    flashTitle: 'property_tax_inactive',
  },
}

export const homeUrl = feature => {
  const { origin } = window.location
  const fixedOrigin =
    process.env.NODE_ENV === 'development' ? origin.replace('5004', '5000') : origin
  const notice = `flash=${config[feature].flashTitle}`

  return `${fixedOrigin}/?${notice}`
}

export function redirectToHomeWhenInactive(toggleActive, feature) {
  if (toggleActive === 'false') window.location = homeUrl(feature)
}

export default {
  redirectToHomeWhenInactive,
}
